import Homepage from "@/Pages/AcessoResponsavel/HomePage.vue";
import PresencasPage from "@/Pages/AcessoResponsavel/PresencasPage.vue";

export default [
  {
    path: "/acesso-responsavel/home",
    name: "acessoResponsavel.home",
    component: Homepage,
  },
  {
    path: "/acesso-responsavel/presencas/:matricula_id",
    name: "presencas.aluno",
    component: PresencasPage,
    props: true,
  },
];
